<template>
  <div class="yld-search-order-container">
    <div class="search-order-input">
      <el-autocomplete
        v-model="currentValue"
        :fetch-suggestions="getList"
        placeholder="请输入订单编号/提单号/箱号/客户单号/订舱号查询"
        style="width: 100%;"
        :maxlength="50"
        popper-class="search-order-input-popper"
        :trigger-on-focus="false"
      >
        <template slot-scope="{item}">
          <div 
            v-if="item.value && item.value.length"
            class="search-order-list-item"
            @click.stop="void(0)"
          >
            <div class="search-order-list-item-title">
              {{ item.name }}
            </div>
            <div class="search-order-list-item-content">
              <list 
                v-for="(ele, k) in item.value"
                :key="k + 'order-list'"
                :data="ele"
                :index="k"
                :num="item.num"
                :data-type="item.type"
              />
              <div 
                v-if="item.value" 
                class="search-order-list-item-content-more"
                @click.stop="onMoreClick(item)"
              >
                查看更多
              </div>
            </div>
          </div>
          <div v-else class="search-order-list-empty">
            <div class="list-empty-center">
              <!-- <img src="" alt=""> -->
              <div class="list-empty-center-content">
                <div>暂无该订单号！</div>
                <div>请输入完整正确的订单号进行查询</div>
              </div>
            </div>
          </div>
        </template>
      </el-autocomplete>
      <yun-icon name="icon-sousuo" />
    </div>
    <el-dropdown 
      placement="bottom"
    >
      <el-button type="primary">
        新建 <yun-icon name="icon-xiala" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="menuClick('1')">新建海运订单</el-dropdown-item>
        <el-dropdown-item @click.native="menuClick('2')">新建空运订单</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { BASE_URL } from '@yld/yun-utils-host'
import { searchSimpleOrder } from '../../../../api/order'
import List from './List/index.vue'

export default {
  name: 'SearchOrder',
  components: {
    List
  },
  data() {
    return {
      loading: false,
      currentValue: '',
    }
  },
  watch: {
    currentValue: {
      handler: function(val) {
        this.currentValue = this.validateInput(val)
      },
    }
  },
  methods: {
    validateInput(input) {
      if(input) {
        //移除空格和制表符
        input = input.replace(/[ \t]/g,'');
        //最大限制50个字符
        if (input.length > 50) {
          return 
        }
        //只允许输入字母和数字
        input = input.replace(/[^A-Za-z0-9/-]/g, '');
        //转换字母为大写
        input = input.toUpperCase();
        return input;
      }
    },
    getList(keyword, cb) {
      keyword = this.validateInput(keyword)
        this.loading = true
      if(keyword) {
        const params = {
        keyword,
        page: 1,
        // 搜索类型 1.订单编号 2.提单号 3.贸易单号 4.箱号 5.订舱号
        // 后端说第一版只能搜订单
        searchTypes: [1,2,3,4,5],
        size: 10
      }
      searchSimpleOrder(params)
        .then(res => {
          this.loading = false
          const data = res.data
          if (data) {
            // 提单号
            const blNos = data?.blNos?.content ? data.blNos.content.filter(item => item.mblNo) : []
            // 箱号
            const containerNos = data?.containerNos?.content || []
            // 订单编号
            const orderNos = data?.orderNos?.content || []
            // 订舱号
            const shipmentNos = data?.shipmentNos?.content || []
            // 订舱单编号
            const shippingOrderNos = data?.shippingOrderNos?.content || []
            // 贸易单号
            const workNos = data?.workNos?.content || []

            const result = [{
              type: 'orderNo',
              name: '订单编号',
              value: orderNos
            }, {
              type: 'mblNo',
              name: '提单号',
              value: blNos
            },{
              type: 'orderContainerNo',
              name: '箱号',
              value: containerNos
            }, {
              type: 'orderShipmentNo',
              name: '订舱号',
              value: shipmentNos
            }, {
              type: 'shippingOrderNo',
              name: '订舱单编号',
              value: shippingOrderNos
            }, {
              type: 'workNo',
              name: '客户单号',
              value: workNos
            }].filter(v => v.value.length)
            cb(result.length ? result : [{}])
          }
        })
        .catch(() => {
          this.loading = false
        })
      } else {
        cb([{}])
        this.loading = false
      }
    },
    menuClick(key) {
      // 权限先不加
      switch(key) {
        case '1':
          this.goFactUrl(`/90010/createorder`)
          break
        case '2':
          this.goFactUrl(`/90010/createAirOrder`)
          break
        default:
          return true
      }
    },
    onMoreClick(val) {
      if(!val.num) {
        this.$set(val, 'num', 10)
      } else {
        if (this.$appId === '90010') {
          let obj = { type: val.type , currentValue:this.currentValue }
          let objStr = JSON.stringify(obj)
          localStorage.setItem('routerValue', objStr);
          this.$router.push(`/${this.$appId}/order?${val.type}=${this.currentValue}`)
        } else {
          let obj = { type: val.type , currentValue:this.currentValue }
          let objStr = JSON.stringify(obj)
          localStorage.setItem('routerValue', objStr);
          const HOME_WORK = BASE_URL.HOME_WORK
          window.open(HOME_WORK + `/90010/order?${val.type}=${this.currentValue}`, '_blank')
        }
      }
     
    },
    goFactUrl(path) {
      if (this.$appId === '90010') {
        this.$router.push(path)
      } else {
        const HOME_WORK = BASE_URL.HOME_WORK
        window.open(HOME_WORK + path, '_blank')
      }
    }
  }
}
</script>
<style lang="scss">
  .yld-search-order-container {
    display: flex;
    align-items: center;
    .search-order-input {
      width: 340px;
      position: relative;
      margin-right: 8px;
      & > svg {
        position: absolute;
        right: 12px;
        top: 8px;
        font-size: 16px;
        color: #ccc;
      }
      .el-input__inner {
        padding-right: 30px;
        font-size: 12px;
      }
    }
    .search-order-create {
      cursor: pointer;
      user-select: none;
      // span {
      //   color: #1AA774;
      //   font-size: 12px;
      // }
      svg {
        margin-left: 4px;
        font-size: 12px;
      }
    }
  }
  .search-order-input-popper {
    min-width: 340px;
    width: auto !important;
    .el-scrollbar__wrap {
      padding: 0;
      margin: 0;
    }
    ul {
      li {
        padding: 0;
        margin: 0;
        border-bottom: 1px solid #e1e1e1;
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .search-order-list-item {
      display: flex;
      .search-order-list-item-title {
        width: 65px;
        border-right: 1px solid #e1e1e1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #333;
      }
      .search-order-list-item-content {
        width: 100%;
        .search-order-list-item-content-more {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: var(--geek-color-primary);
          &:hover {
            background: #f1f0f0;
          }
        }
      }
    }
    .search-order-list-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 30px 0;
      .list-empty-center {
        .list-empty-center-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          & > div {
            color: #333;
            font-size: 12px;
            line-height: 17px;
            margin-bottom: 6px;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
</style>